import React from 'react'
import { StarRating } from '@deal/components'
import styles from './styles.css'
import { usePathContext } from '../../PathContext'

interface Props {
  categorySlug?: string
}

const RatingCopyMap: {
  [key: string]: {
    header: string
    body: string
  }
} = {
  golf: {
    header: 'Golfers love us!',
    body:
      'Curated golf experts are rated 4.7 out of 5 because they helped golfers find gear they love.'
  },
  default: {
    header: 'Our customers love us!',
    body: 'Curated experts are rated 4.7 out of 5 because they help people find the gear they love.'
  }
}

const RatingContactPageMetadataHeader: React.SFC<Props> = ({ categorySlug }) => {
  const pathContext = usePathContext()

  // This one has a special rendering treatment, just it's existence renders this
  const ratingWrapperMetaData = pathContext.pathFlowPage.metadata.find(
    metadata => metadata.__typename === 'RatingContactPageMetadata'
  )

  if (!ratingWrapperMetaData) {
    return null
  }

  const copyObj =
    categorySlug && RatingCopyMap[categorySlug]
      ? RatingCopyMap[categorySlug]
      : RatingCopyMap.default

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>{copyObj.header}</div>
      <div className={styles.stars}>
        <StarRating rating={4.7} starDimension="35" />
      </div>
      <div className={styles.body}>{copyObj.body}</div>
    </div>
  )
}

export default RatingContactPageMetadataHeader
